import { render } from "./empty-history-message.vue?vue&type=template&id=bac679d0&ts=true"
import script from "./empty-history-message.ts?vue&type=script&lang=ts&external"
export * from "./empty-history-message.ts?vue&type=script&lang=ts&external"

import "./empty-history-message.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__